import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { instalarAvisoDeActualizacion } from "@/lib/actualizacionApp";
import { iniciarSentry } from "@/lib/sentry";

// Antes de montar, para que los errores del primer render también se reporten.
iniciarSentry();

if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          void registration.unregister();
        });
      });
    }

    if ("caches" in window) {
      void caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          void caches.delete(cacheName);
        });
      });
    }
  });
}

// Antes de montar: si el despliegue dejó esta pestaña con el build anterior, el
// primer `import()` que falle tiene que explicarse solo. Ver `actualizacionApp`.
instalarAvisoDeActualizacion();

createRoot(document.getElementById("root")!).render(<App />);
